module.exports = __webpack_public_path__ + "img/equityStructureBase.865fdfb4.jpg";